import Accordion from "react-bootstrap/Accordion";
import { Container } from "react-bootstrap";
import Seo from "../components/modules/Seo";
import PageHero from "../components/ui/PageHero";
import { Reveal } from "../components/ui/Reveal";
import "../components/style/Faq.css";

const objSeo = {
  title: "FAQ: Idly Dosa Batter Preparation and Product Authenticity",
  keywords:
    " Idly Dosa batter, preparation process, product authenticity, finest quality ingredients, locally sourced, fresh products, authentic taste,  FAQ, frequently asked questions, Bagalkot, Karnataka",
  pathSlug: "/faq",
  baseUrl: "https://bitbytefoods.com/",
  description:
    "Welcome to our FAQ page, where we address common questions about our products and our commitment to maintaining product authenticity.",
};

const FAQS = [
  {
    q: "What makes your idly and dosa batter special?",
    a: "We take pride in using only natural ingredients and avoiding preservatives in our batter. Our idly and dosa batter is made with care and attention to quality, ensuring a delicious and healthy option for our customers.",
  },
  {
    q: "Where can I get these products?",
    a: (
      <>
        We are currently located in <strong>Bagalkot</strong>, offering our
        idly and dosa batter to customers in the local area. However, we have
        plans to expand to nearby places in the near future.
      </>
    ),
  },
  {
    q: "Do you add soda to your batter?",
    a: (
      <>
        No, <strong>we do not add soda to our idly and dosa batter.</strong>{" "}
        Our batter is made using traditional methods, without the use of any
        artificial additives or soda.
      </>
    ),
  },
  {
    q: "Is the batter used in your restaurant made in-house?",
    a: "Yes, the batter used in our restaurant is made in-house using our own specially crafted recipe. We take great care in preparing our batter to ensure the best taste and quality for our customers.",
  },
  {
    q: "Are there any preservatives in your batter?",
    a: "No, we do not use any preservatives in our idly and dosa batter. We believe in providing our customers with a natural and healthy option for their meals.",
  },
  {
    q: "How do you ensure the freshness of your batter?",
    a: "We take great care in preparing our batter fresh each day to ensure its quality and freshness. Our batter is made in small batches, and we do not use any preservatives or additives, ensuring a natural and fresh product.",
  },
];

const Faq = () => {
  return (
    <div>
      <Seo data={objSeo} />
      <PageHero
        eyebrow="Good to Know"
        title="Frequently Asked Questions"
        subtitle="Everything customers most often ask us about the batter, the process, and the ingredients."
      />
      <section className="section-pad faq-page">
        <Container className="container-narrow container-narrow--tight">
          <Reveal>
            <Accordion className="faq-page__accordion" defaultActiveKey="0">
              {FAQS.map(({ q, a }, i) => (
                <Accordion.Item eventKey={String(i)} key={q}>
                  <Accordion.Header>{q}</Accordion.Header>
                  <Accordion.Body>{a}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Reveal>
          <p className="faq-page__more">
            Still have a question?{" "}
            <a href="/contactus">Get in touch with us</a>.
          </p>
        </Container>
      </section>
    </div>
  );
};

export default Faq;
